<div class="doc-page">

  <p-toast position="top-right" />

  <!-- En-tête ──────────────────────────────────────────────────────────────── -->
  <div class="page-top">
    <div>
      <h1 class="page-title">Documents d'inscription</h1>
      <p class="page-subtitle">Vérification des pièces soumises lors de l'enregistrement</p>
    </div>
    @if (!loadingPending()) {
      <div class="kpi-chips">
        <span class="kpi-chip kpi-pending">
          <i class="pi pi-clock"></i>
          {{ countByStatus('PENDING_VALIDATION') }} en attente
        </span>
        @if (countByStatus('ERROR') > 0) {
          <span class="kpi-chip kpi-error">
            <i class="pi pi-exclamation-triangle"></i>
            {{ countByStatus('ERROR') }} erreur{{ countByStatus('ERROR') > 1 ? 's' : '' }} scan
          </span>
        }
      </div>
    }
  </div>

  <!-- Onglets ──────────────────────────────────────────────────────────────── -->
  <p-tabs [value]="activeTab()" (valueChange)="onTabChange($event)" class="doc-tabs">
    <p-tablist>
      <p-tab value="0">
        <i class="pi pi-hourglass tab-icon"></i>
        En attente
        @if (pendingDocs().length > 0) {
          <span class="tab-badge tab-badge--warn">{{ pendingDocs().length }}</span>
        }
      </p-tab>
      <p-tab value="1">
        <i class="pi pi-check-circle tab-icon"></i>
        Validés
        @if (validatedDocs().length > 0) {
          <span class="tab-badge">{{ validatedDocs().length }}</span>
        }
      </p-tab>
    </p-tablist>

    <p-tabpanels>

      <!-- Panel 1 : En attente ─────────────────────────────────────────── -->
      <p-tabpanel value="0">
        @if (loadingPending()) {
          <div class="loading-wrap"><p-progressSpinner strokeWidth="4" styleClass="spinner-sm" /></div>
        } @else {
          <div class="table-wrap">
            <p-table [value]="pendingDocs()" [paginator]="pendingDocs().length > 10" [rows]="10"
                     [rowHover]="true" styleClass="doc-table" [showCurrentPageReport]="true"
                     currentPageReportTemplate="{first} - {last} sur {totalRecords}">
              <ng-template #header>
                <tr>
                  <th>Utilisateur</th>
                  <th>Type</th>
                  <th>Fichier</th>
                  <th>Statut</th>
                  <th></th>
                </tr>
              </ng-template>
              <ng-template #body let-doc>
                <tr>
                  <td class="cell-main">
                    <div class="user-cell">
                      <div class="user-avatar">{{ ownerInitials(doc) }}</div>
                      <div>
                        <div class="user-name">{{ ownerName(doc) }}</div>
                        <div class="user-email">{{ doc.ownerEmail || '—' }}</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span class="chip-type"><i class="pi" [ngClass]="docIcon(doc.documentType)"></i>{{ docTypeLabel(doc.documentType) }}</span>
                  </td>
                  <td class="cell-file">{{ doc.fileName || 'Fichier sans nom' }}</td>
                  <td><app-status-tag [label]="statusLabel(doc.documentStatus)" [severity]="statusSeverity(doc.documentStatus)" /></td>
                  <td class="cell-action">
                    <button pButton [outlined]="true" class="btn-view"
                            [disabled]="doc.documentStatus === 'ERROR'"
                            (click)="openDoc(doc.id)"
                            icon="pi pi-external-link" label="Consulter"
                            [pTooltip]="doc.documentStatus === 'ERROR' ? 'Fichier indisponible (échec du scan)' : 'Consulter le fichier'"></button>

                    @if (doc.documentStatus === 'PENDING_VALIDATION' && authService.hasPermission('DOCUMENTS_VALIDATE')) {
                      <button pButton class="btn-validate" [disabled]="processing() === doc.id" [loading]="processing() === doc.id"
                              (click)="validate(doc)" icon="pi pi-check-circle" label="Valider"></button>
                      <button pButton severity="danger" [outlined]="true" class="btn-reject"
                              [disabled]="processing() === doc.id"
                              (click)="startReject(doc)" icon="pi pi-times-circle" label="Rejeter"></button>
                    }
                  </td>
                </tr>
              </ng-template>
              <ng-template #emptymessage>
                <tr>
                  <td colspan="5">
                    <app-empty-state icon="pi-check-circle" iconVariant="success"
                                      title="Aucun document en attente"
                                      message="Tous les documents d'inscription ont été traités." />
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        }
      </p-tabpanel>

      <!-- Panel 2 : Validés ────────────────────────────────────────────── -->
      <p-tabpanel value="1">
        @if (loadingValidated()) {
          <div class="loading-wrap"><p-progressSpinner strokeWidth="4" styleClass="spinner-sm" /></div>
        } @else {
          <div class="table-wrap">
            <p-table [value]="validatedDocs()" [paginator]="validatedDocs().length > 10" [rows]="10"
                     [rowHover]="true" styleClass="doc-table" [showCurrentPageReport]="true"
                     currentPageReportTemplate="{first} - {last} sur {totalRecords}">
              <ng-template #header>
                <tr>
                  <th>Utilisateur</th>
                  <th>Type</th>
                  <th>Fichier</th>
                  <th>Statut</th>
                  <th></th>
                </tr>
              </ng-template>
              <ng-template #body let-doc>
                <tr>
                  <td class="cell-main">
                    <div class="user-cell">
                      <div class="user-avatar">{{ ownerInitials(doc) }}</div>
                      <div>
                        <div class="user-name">{{ ownerName(doc) }}</div>
                        <div class="user-email">{{ doc.ownerEmail || '—' }}</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span class="chip-type"><i class="pi" [ngClass]="docIcon(doc.documentType)"></i>{{ docTypeLabel(doc.documentType) }}</span>
                  </td>
                  <td class="cell-file">{{ doc.fileName || 'Fichier sans nom' }}</td>
                  <td><app-status-tag [label]="statusLabel(doc.documentStatus)" severity="success" /></td>
                  <td class="cell-action">
                    <button pButton [outlined]="true" class="btn-view" (click)="openDoc(doc.id)"
                            icon="pi pi-external-link" label="Consulter" pTooltip="Consulter le fichier"></button>
                  </td>
                </tr>
              </ng-template>
              <ng-template #emptymessage>
                <tr>
                  <td colspan="5">
                    <app-empty-state icon="pi-inbox" title="Aucun document validé"
                                      message="Les documents validés apparaîtront ici." />
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        }
      </p-tabpanel>

    </p-tabpanels>
  </p-tabs>

  <!-- Dialogue de rejet ────────────────────────────────────────────────────── -->
  <app-document-reject-dialog 
    [(visible)]="rejectDialogVisible" 
    [(text)]="rejectText"
    [loading]="processing() === rejectTarget()?.id"
    (confirm)="confirmReject()" (cancel)="cancelReject()" 
  />
</div>
